import Vue from 'vue'
import Button from '../components/Button'
import ButtonSet from '../components/ButtonSet'
import Form from '../components/Form'
import Input from '../components/Input'
import Loader from '../components/Loader'
import Text from '../components/Text'
import Box from '../components/Box'
import Actions from '../components/Actions'
import Link from '../components/Link'
import Checkbox from '../components/Checkbox'
import Icon from '../components/Icon'
import Step from '../components/Step'

Vue.component('a-btn', Button)
Vue.component('a-btn-set', ButtonSet)
Vue.component('a-form', Form)
Vue.component('a-input', Input)
Vue.component('a-loader', Loader)
Vue.component('a-text', Text)
Vue.component('a-box', Box)
Vue.component('a-actions', Actions)
Vue.component('a-link', Link)
Vue.component('a-checkbox', Checkbox)
Vue.component('a-icon', Icon)
Vue.component('a-step', Step)

